import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../../Tabels/Tabels.css";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import ModalSave from "../../../common/ModelSave";
import { CancelButton } from "../../../common/Button";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
library.add(fas);

const EditOffCanvance = (props) => {
  const { getData } = useContext(Context);

  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    designation: "",
    job_profile: "",
    users_type_id: "",
  });

  const GetEditData = async () => {
    const response = await getData(
      `/masters/job-portal/customer-management/job-seeker/details/${id}`
    );
    setFormData(response?.data);
    console.log(formData);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  return (
    <>
      <Modal
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true} // Assuming you're controlling the modal visibility from outside
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            View Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Name:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.first_name} {formData?.job_seeker_personal_detail?.middle_name} {formData?.last_name}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Email:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.email}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Phone:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_portal_users_detail?.contact_no}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Designation:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_portal_users_detail?.Profile_Title || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row> */}
          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Job Profile:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_portal_users_detail?.Profile_Title || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    DOB:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_seeker_personal_detail?.date_of_birth || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Gender:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_seeker_personal_detail?.gender || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Career Level:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_seeker_personal_detail?.career_level || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Current Address:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_seeker_personal_detail?.current_address || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Col sm={3} className="text-center">
                    Permanent Address:
                  </Col>
                  <Col sm={9} className="text-center">
                    {formData?.job_seeker_personal_detail?.permenent_address || "N/A"}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>


          {/* Buttons */}
          <Row className="justify-content-center mt-5 pb-3">
            <Col sm={6} className="d-flex justify-content-center">
              <CancelButton name={"Close"} handleClose={props.handleClose} />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
